// @mui
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
//
import { EnvIcon } from '@/components/core/env-icon';
import { HeaderSimple as Header } from '../_common';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function CompactLayout({ children }: Props) {
  return (
    <>
      <Header />

      <Container component="main">
        <Stack
          sx={{
            py: 10,
            px: { xs: 2, sm: 3 },
            m: 'auto',
            maxWidth: 400,
            minHeight: '100vh',
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          <EnvIcon />

          {children}
        </Stack>
      </Container>
    </>
  );
}
